import { createAction } from '@ngrx/store';

const subscribeToOffer = createAction('[Offer Shell] Subscribe to offer topic');
const clearOffer = createAction('[Offer Shell] Unsubscribe to offer topic');
const autoRefreshMaterials = createAction('[Offer Shell] Refresh materials');
const clearOfferRelatedCache = createAction('[Offer Shell] Clear offer related cache');
const reloadMaterials = createAction('[Offer Shell] Reload materials');

export const OfferShellActions = {
  subscribeToOffer,
  clearOffer,
  clearOfferRelatedCache,
  autoRefreshMaterials,
  reloadMaterials,
};
